import { render, staticRenderFns } from "./CaetanoGo.vue?vue&type=template&id=0131a34d&"
import script from "./CaetanoGo.vue?vue&type=script&lang=js&"
export * from "./CaetanoGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports